import { t } from 'i18next';
import { toast, ToastOptions } from 'react-toastify';
import { EMessageType } from '../data/Constants';

/**
 * This function  shows the toast messsage using react-toastify
 * @param { string} message message
 * @param {string} type message type
 * @param {boolean} showDefault show default message
 */
export function showToastMessage(type: EMessageType, message: string, showDefault: boolean = true) {
  switch (type) {
    case EMessageType.Error:
      handleError(message, showDefault);
      break;
    case EMessageType.Success:
      handleSuccess(message, showDefault);
      break;
    case EMessageType.Info:
      toast.info(message);
      break;
    default:
      toast(message);
  }
}

/**
 * This function shows the error toast message if getting error from the api.
 * @param {string} message toast message
 * @param {boolean} showDefault show default message
 */
export function handleError(message: string, showDefault: boolean = true) {
  let errorMessage = message ? t('message.error.general') + message : t('message.error.default');
  if (!showDefault) {
    errorMessage = message;
  }

  const toastOptions: ToastOptions = {
    position: 'bottom-center',
    autoClose: 5000,
    closeOnClick: false,
    theme: 'colored',
    draggable: true,
  };

  toast.error(errorMessage, toastOptions);
}

/**
 * This function shows the success toast message if getting valid response from the api.
 * @param {string} message
 * @param {boolean} showDefault show default message
 */
export function handleSuccess(message: string, showDefault: boolean = true) {
  let successMessage = message
    ? t('message.success.general') + message
    : t('message.success.default');
  if (!showDefault) {
    successMessage = message;
  }

  const toastOptions: ToastOptions = {
    position: 'bottom-center',
    autoClose: 5000,
    closeOnClick: false,
    theme: 'colored',
    draggable: true,
  };
  toast.success(successMessage, toastOptions);
}
